import { render } from "./DisclaimerText.vue?vue&type=template&id=c4a2405a&scoped=true"
import script from "./DisclaimerText.vue?vue&type=script&lang=js"
export * from "./DisclaimerText.vue?vue&type=script&lang=js"

import "./DisclaimerText.vue?vue&type=style&index=0&id=c4a2405a&lang=scss&scoped=true"

import exportComponent from "/srv/users/dyo-frontend/apps/dyo-frontend/public_html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4a2405a"]])

export default __exports__